import React from "react";

import { Value } from "lib/build/schema";

import { api } from "src/common/utils/api";
import { useCreateGenericError } from "src/features/notifications";

export function useInitialValue(): readonly [boolean, Value | null] {
	const [{ value, isLoading }, setState] = React.useState<{
		isLoading: boolean;
		value: Value | null;
	}>({
		isLoading: true,
		value: null
	});

	const createGenericError = useCreateGenericError();

	const fetch = React.useCallback(async () => {
		setState({ isLoading: true, value: null });
		try {
			const { data } = await api.get<Value>("/profile");
			setState({ isLoading: false, value: data });
		} catch {
			createGenericError();
		}
	}, [createGenericError]);

	React.useEffect(() => {
		fetch();
	}, [fetch]);

	return [isLoading, value];
}
